export const TABLE_STATION_TABS = [
  { label: "DON9 AMZN", value: 1 },
  { label: "AMXL HYZ1", value: 19 },
  { label: "Metro Oshawa", value: 25 },
];

export const TABLE_SIDE_ROWS = [
  { id: "standard-cargo", editRow: false, label: "Standard", sizeLabel: "Cargo", role: 0, vans: [1, 5], hour: [null, 10, 9] },
  { id: "standard-large", editRow: false, label: "Standard", sizeLabel: "Large", role: 0, vans: [2], hour: [null, 10, 9] },
  {
    id: "standard-cube",
    editRow: false,
    label: "Standard",
    sizeLabel: "Cube",
    role: 0,
    vans: [3],
    hour: [null, 10, 9],
  },
  {
    id: "standard-medium",
    editRow: false,
    label: "Standard",
    sizeLabel: "Medium",
    role: 0,
    vans: [6],
    hour: [null, 10, 9],
  },
  { id: "standard-other", editRow: false, label: "Standard", sizeLabel: "n/a", role: 0, vans: [null], hour: [null, 10, 9] },
  {
    id: "flex-cargo-10",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [10],
  },
  {
    id: "flex-cargo-9",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [9],
  },
  {
    id: "flex-cargo-8",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [8],
  },
  {
    id: "flex-cargo-7",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [7],
  },
  {
    id: "flex-cargo-6",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [6],
  },
  {
    id: "flex-cargo-5",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [5],
  },
  {
    id: "flex-cargo-4",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [4],
  },
  {
    id: "flex-cargo-3",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [3],
  },
  {
    id: "flex-cargo-2",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [2],
  },
  {
    id: "flex-cargo-1",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [1],
  },
  {
    id: "flex-cargo-0",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [0],
  },

  {
    id: "flex-large-10",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [10],
  },
  {
    id: "flex-large-9",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [9],
  },
  {
    id: "flex-large-8",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [8],
  },
  {
    id: "flex-large-7",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [7],
  },
  {
    id: "flex-large-6",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [6],
  },
  {
    id: "flex-large-5",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [5],
  },
  {
    id: "flex-large-4",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [4],
  },
  {
    id: "flex-large-3",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [3],
  },
  {
    id: "flex-large-2",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [2],
  },
  {
    id: "flex-large-1",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [1],
  },
  {
    id: "flex-large-0",
    editRow: false,
    label: "Flex",
    sizeLabel: "Large",
    role: 8,
    vans: [2],
    hour: [0],
  },

  {
    id: "flex-cube-10",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [10],
  },
  {
    id: "flex-cube-9",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [9],
  },
  {
    id: "flex-cube-8",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [8],
  },
  {
    id: "flex-cube-7",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [7],
  },
  {
    id: "flex-cube-6",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [6],
  },
  {
    id: "flex-cube-5",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [5],
  },
  {
    id: "flex-cube-4",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [4],
  },
  {
    id: "flex-cube-3",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [3],
  },
  {
    id: "flex-cube-2",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [2],
  },
  {
    id: "flex-cube-1",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [1],
  },
  {
    id: "flex-cube-0",
    editRow: false,
    label: "Flex",
    sizeLabel: "Cube",
    role: 8,
    vans: [3],
    hour: [0],
  },

  {
    id: "flex-medium-10",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [10],
  },
  {
    id: "flex-medium-9",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [9],
  },
  {
    id: "flex-medium-8",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [8],
  },
  {
    id: "flex-medium-7",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [7],
  },
  {
    id: "flex-medium-6",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [6],
  },
  {
    id: "flex-medium-5",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [5],
  },
  {
    id: "flex-medium-4",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [4],
  },
  {
    id: "flex-medium-3",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [3],
  },
  {
    id: "flex-medium-2",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [2],
  },
  {
    id: "flex-medium-1",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [1],
  },
  {
    id: "flex-medium-0",
    editRow: false,
    label: "Flex",
    sizeLabel: "Medium",
    role: 8,
    vans: [6],
    hour: [0],
  },

  {
    id: "da-training",
    editRow: false,
    label: "DA Training",
    sizeLabel: "n/a",
    role: 4,
    vans: [1, 2, 5, 6, null],
    hour: [null, 3],
  },

  {
    id: "client-cancelled-cargo",
    editRow: false,
    label: "Client Cancellation",
    sizeLabel: "Cargo",
    role: 7,
    vans: [1, 5],
    hour: [null, 0],
  },
  {
    id: "client-cancelled-medium",
    editRow: false,
    label: "Client Cancellation",
    sizeLabel: "Medium",
    role: 7,
    vans: [6],
    hour: [null, 0],
  },
  {
    id: "client-cancelled-cube",
    editRow: false,
    label: "Client Cancellation",
    sizeLabel: "Cube",
    role: 7,
    vans: [3],
    hour: [null, 0],
  },
  {
    id: "client-cancelled-large",
    editRow: false,
    label: "Client Cancellation",
    sizeLabel: "Large",
    role: 7,
    vans: [2],
    hour: [null, 0],
  },
  {
    id: "client-cancelled-other",
    editRow: false,
    label: "Client Cancellation",
    sizeLabel: "n/a",
    role: 7,
    vans: [null],
    hour: [null, 0],
  },
  {
    id: "mycu-cancelled-cargo",
    editRow: false,
    label: "MYCU Cancellation",
    sizeLabel: "Cargo",
    role: 9,
    vans: [1, 5],
    hour: [null, 0],
  },
  {
    id: "mycu-cancelled-medium",
    editRow: false,
    label: "MYCU Cancellation",
    sizeLabel: "Medium",
    role: 9,
    vans: [6],
    hour: [null, 0],
  },
  {
    id: "mycu-cancelled-cube",
    editRow: false,
    label: "MYCU Cancellation",
    sizeLabel: "Cube",
    role: 9,
    vans: [3],
    hour: [null, 0],
  },
  {
    id: "mycu-cancelled-large",
    editRow: false,
    label: "MYCU Cancellation",
    sizeLabel: "Large",
    role: 9,
    vans: [2],
    hour: [null, 0],
  },
  {
    id: "mycu-cancelled-other",
    editRow: false,
    label: "MYCU Cancellation",
    sizeLabel: "n/a",
    role: 9,
    vans: [null],
    hour: [null, 0],
  },
];

export const TABLE_SIDE_ROWS_TWO = [
  {
    id: "abscent-cargo",
    editRow: false,
    label: "No Show",
    sizeLabel: "Cargo",
    role: 1,
    vans: [1, 5],
    hour: [null, 0],
  },
  {
    id: "abscent-medium",
    editRow: false,
    label: "No Show",
    sizeLabel: "Medium",
    role: 1,
    vans: [6],
    hour: [null, 0],
  },
  {
    id: "abscent-cube",
    editRow: false,
    label: "No Show",
    sizeLabel: "Cube",
    role: 1,
    vans: [3],
    hour: [null, 0],
  },
  {
    id: "abscent-large",
    editRow: false,
    label: "No Show",
    sizeLabel: "Large",
    role: 1,
    vans: [2],
    hour: [null, 0],
  },

  {
    id: "standby-cargo",
    editRow: false,
    label: "Standby",
    sizeLabel: "Cargo",
    role: 3,
    vans: [1, 5],
    hour: [null, 3],
  },
  {
    id: "standby-medium",
    editRow: false,
    label: "Standby",
    sizeLabel: "Medium",
    role: 3,
    vans: [6],
    hour: [null, 3],
  },
  {
    id: "standby-cube",
    editRow: false,
    label: "Standby",
    sizeLabel: "Cube",
    role: 3,
    vans: [3],
    hour: [null, 3],
  },
  {
    id: "standby-large",
    editRow: false,
    label: "Standby",
    sizeLabel: "Large",
    role: 3,
    vans: [2],
    hour: [null, 3],
  },

  {
    id: "quality-cargo",
    editRow: false,
    label: "Quality",
    sizeLabel: "Cargo",
    role: 5,
    vans: [1, 5],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "quality-medium",
    editRow: false,
    label: "Quality",
    sizeLabel: "Medium",
    role: 5,
    vans: [6],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "quality-cube",
    editRow: false,
    label: "Quality",
    sizeLabel: "Cube",
    role: 5,
    vans: [3],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "quality-large",
    editRow: false,
    label: "Quality",
    sizeLabel: "Large",
    role: 5,
    vans: [2],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },

  {
    id: "special-cargo",
    editRow: false,
    label: "Special",
    sizeLabel: "Cargo",
    role: 6,
    vans: [1, 5],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "special-medium",
    editRow: false,
    label: "Special",
    sizeLabel: "Medium",
    role: 6,
    vans: [6],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "special-cube",
    editRow: false,
    label: "Special",
    sizeLabel: "Cube",
    role: 6,
    vans: [3],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    id: "special-large",
    editRow: false,
    label: "Special",
    sizeLabel: "Large",
    role: 6,
    vans: [2],
    hour: [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },

  {
    id: "rescue-cargo-9",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 8,
    vans: [1, 5],
    hour: [9],
  },
  {
    id: "rescue-cargo-8",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [8],
  },
  {
    id: "rescue-cargo-7",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [7],
  },
  {
    id: "rescue-cargo-6",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [6],
  },
  {
    id: "rescue-cargo-5",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [5],
  },
  {
    id: "rescue-cargo-4",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [4],
  },
  {
    id: "rescue-cargo-3",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [3],
  },
  {
    id: "rescue-cargo-2",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [2],
  },
  {
    id: "rescue-cargo-1",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [1],
  },
  {
    id: "rescue-cargo-0",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cargo",
    role: 2,
    vans: [1, 5],
    hour: [0],
  },

  {
    id: "rescue-large-9",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [9],
  },
  {
    id: "rescue-large-8",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [8],
  },
  {
    id: "rescue-large-7",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [7],
  },
  {
    id: "rescue-large-6",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [6],
  },
  {
    id: "rescue-large-5",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [5],
  },
  {
    id: "rescue-large-4",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [4],
  },
  {
    id: "rescue-large-3",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [3],
  },
  {
    id: "rescue-large-2",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [2],
  },
  {
    id: "rescue-large-1",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [1],
  },
  {
    id: "rescue-large-0",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Large",
    role: 2,
    vans: [2],
    hour: [0],
  },

  {
    id: "rescue-cube-9",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [9],
  },
  {
    id: "rescue-cube-8",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [8],
  },
  {
    id: "rescue-cube-7",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [7],
  },
  {
    id: "rescue-cube-6",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [6],
  },
  {
    id: "rescue-cube-5",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [5],
  },
  {
    id: "rescue-cube-4",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [4],
  },
  {
    id: "rescue-cube-3",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [3],
  },
  {
    id: "rescue-cube-2",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [2],
  },
  {
    id: "rescue-cube-1",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [1],
  },
  {
    id: "rescue-cube-0",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Cube",
    role: 2,
    vans: [3],
    hour: [0],
  },

  {
    id: "rescue-medium-9",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [9],
  },
  {
    id: "rescue-medium-8",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [8],
  },
  {
    id: "rescue-medium-7",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [7],
  },
  {
    id: "rescue-medium-6",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [6],
  },
  {
    id: "rescue-medium-5",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [5],
  },
  {
    id: "rescue-medium-4",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [4],
  },
  {
    id: "rescue-medium-3",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [3],
  },
  {
    id: "rescue-medium-2",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [2],
  },
  {
    id: "rescue-medium-1",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [1],
  },
  {
    id: "rescue-medium-0",
    editRow: false,
    label: "Rescue",
    sizeLabel: "Medium",
    role: 2,
    vans: [6],
    hour: [0],
  },
];

export const TABLE_SIDE_ROWS_THREE = [
  {
    id: "planned",
    editRow: false,
    label: "Planned",
    sizeLabel: "",
    role: null,
    vans: [],
    hour: [null],
  },
  {
    id: "large-van",
    editRow: true,
    label: "Large Van",
    sizeLabel: "",
    role: null,
    vans: [],
    hour: [null],
  },
  {
    id: "box-truck",
    editRow: true,
    label: "Box Truck",
    sizeLabel: "",
    role: null,
    vans: [],
    hour: [null],
  },
  {
    id: "actual-billed",
    editRow: false,
    label: "Actual Billed",
    sizeLabel: "",
    roles: [0, 8],
    vans: [1, 2, 5, 6, null],
    hour: [null],
  },
  {
    id: "difference",
    editRow: false,
    label: "Difference (%)",
    sizeLabel: "",
    roles: [0, 8],
    vans: [],
    hour: [null],
  },
];

export const TABLE_CORRECTION_COLS = ["Route", "Size", "Hours", "Total"];
